import AntSkeleton, { type SkeletonProps as AntSkeletonProps } from "antd/lib/skeleton";

export type SkeletonProps = AntSkeletonProps;

export const Skeleton = (props: SkeletonProps) => {
    return <AntSkeleton {...props} />;
};

Skeleton.Avatar = AntSkeleton.Avatar;
Skeleton.Input = AntSkeleton.Input;
Skeleton.Button = AntSkeleton.Button;
Skeleton.Image = AntSkeleton.Image;
Skeleton.Node = AntSkeleton.Node;
